export enum MapModes {
  SCATTER = "Scatter",
  HEATMAP = "Heatmap",
}
